// Mutation hook: zatwierdzenie koszyka w workflow akceptacji

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

export interface IPayload {
  notice?: string;
}

const postCartToApproveAccept = (cartId: number, payload: IPayload): Promise<IResponse> =>
  axios.post(`/carts-to-approve/${cartId}/accept`, payload);

export const usePostCartToApproveAccept = (
  cartId: number,
  options?: UseMutationOptions<IResponse, IError, IPayload>
) =>
  useMutation<IResponse, IError, IPayload>(
    (payload) => postCartToApproveAccept(cartId, payload),
    options
  );
